import clsx from 'clsx';
import React from 'react';

import IconTIProExclusive from '@components/Images/Rebranding/IconTIProExclusive';

interface ProExclusiveLogoProps {
  align?: 'center' | 'left';
}

const ProExclusiveLogo = ({ align = 'center' }: ProExclusiveLogoProps) => {
  return (
    <div
      className={clsx(
        'mb-24 border-0 border-b-2 border-solid border-grayscale-beige pb-24 sm:mb-32 sm:pb-32',
        {
          'mx-auto max-w-[720px] text-center': align === 'center',
          'text-left': align === 'left',
        }
      )}
    >
      <IconTIProExclusive className="w-[125px]" />
    </div>
  );
};

export default ProExclusiveLogo;
